var _defs, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKursObraczki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 258.1 292.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;}.cls-2{fill:#ac893a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "kurs_obraczki") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.5,163.4a78.08,78.08,0,0,0-43.8-70.1,37.27,37.27,0,0,0-3.5-1.6q-3.6-1.5-7.2-2.7c-1.2-.4-2.3-.7-3.5-1q-3.6-.9-7.2-1.5c-1.2-.2-2.3-.3-3.5-.5-2.4-.3-4.8-.4-7.2-.5h-3.5c-2.4.1-4.9.2-7.2.5-1.2.1-2.3.3-3.5.5q-3.75.6-7.2,1.5c-1.2.3-2.3.6-3.5,1-2.5.8-4.9,1.7-7.2,2.6-1.2.5-2.3,1-3.5,1.6a63,63,0,0,0-7.2,4c-1.2.7-2.4,1.5-3.5,2.3q-3.75,2.7-7.2,5.7c-1.2,1.1-2.4,2.2-3.5,3.3a72.44,72.44,0,0,0-7.2,8.4c-1.2,1.7-2.4,3.4-3.5,5.1a73.17,73.17,0,0,0-7.2,14.9,75.39,75.39,0,0,0-3.5,13.4,76.19,76.19,0,0,0,0,25.8,75.39,75.39,0,0,0,3.5,13.4,81.86,81.86,0,0,0,7.2,14.9c1.1,1.8,2.3,3.5,3.5,5.1a72.44,72.44,0,0,0,7.2,8.4c1.1,1.1,2.3,2.2,3.5,3.3a78.29,78.29,0,0,0,7.2,5.7c1.1.8,2.3,1.6,3.5,2.3a63,63,0,0,0,7.2,4,37.27,37.27,0,0,0,3.5,1.6,69.28,69.28,0,0,0,7.2,2.6c1.2.4,2.3.7,3.5,1q3.6.9,7.2,1.5c1.2.2,2.3.3,3.5.5,2.4.3,4.8.4,7.2.5h3.5c2.4-.1,4.9-.2,7.2-.5,1.2-.1,2.3-.3,3.5-.5q3.75-.6,7.2-1.5c1.2-.3,2.3-.6,3.5-1a76.59,76.59,0,0,0,7.2-2.7c1.2-.5,2.3-1,3.5-1.6A77,77,0,0,0,230.5,163.4Z",
    transform: "translate(-21.1 -16.6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.6,164.2a12.29,12.29,0,1,1-3.6-8.8A11.92,11.92,0,0,1,248.6,164.2Z",
    transform: "translate(-21.1 -16.6)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    x2: 0.5,
    y2: 292.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.8,
    x2: 9.8,
    y2: 292.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.1,
    y1: 118,
    x2: 19.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.1,
    y1: 177.3,
    x2: 19.1,
    y2: 292.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28.4,
    x2: 28.4,
    y2: 94.1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28.4,
    y1: 201.3,
    x2: 28.4,
    y2: 292.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.7,
    x2: 37.7,
    y2: 79.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.7,
    y1: 292.4,
    x2: 37.7,
    y2: 216.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.2,
    y1: 59.3,
    x2: 56.2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.2,
    y1: 236.1,
    x2: 56.2,
    y2: 292.4
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.9,
    y1: 292.4,
    x2: 46.9,
    y2: 227.3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.9,
    x2: 46.9,
    y2: 68.1
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.5,
    y1: 243.2,
    x2: 65.5,
    y2: 292.4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.5,
    x2: 65.5,
    y2: 52.2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.8,
    y1: 292.4,
    x2: 74.8,
    y2: 248.9
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.8,
    x2: 74.8,
    y2: 46.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.1,
    y1: 292.4,
    x2: 84.1,
    y2: 253.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.1,
    x2: 84.1,
    y2: 41.9
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.4,
    y1: 292.4,
    x2: 93.4,
    y2: 257.2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.4,
    x2: 93.4,
    y2: 38.2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 102.7,
    x2: 102.7,
    y2: 35.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 102.7,
    y1: 292.4,
    x2: 102.7,
    y2: 259.9
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112,
    x2: 112,
    y2: 33.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 112,
    y1: 292.4,
    x2: 112,
    y2: 261.8
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.6,
    x2: 130.6,
    y2: 32
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.6,
    y1: 292.4,
    x2: 130.6,
    y2: 263.4
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.3,
    y1: 292.4,
    x2: 121.3,
    y2: 263
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.3,
    x2: 121.3,
    y2: 32.4
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 139.9,
    y1: 263,
    x2: 139.9,
    y2: 292.4
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 139.9,
    y1: 32.3,
    x2: 139.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.7,164.3A115.73,115.73,0,0,0,161,48.9q-4.5-.3-9-.3h-.3c-3.1,0-6.2.1-9.3.4s-6.2.6-9.3,1.1-6.2,1.2-9.3,1.9-6.3,1.7-9.3,2.7q-4.8,1.65-9.3,3.6c-3.2,1.4-6.3,3-9.3,4.6-3.2,1.8-6.3,3.7-9.3,5.8-3.2,2.2-6.3,4.6-9.3,7.1A111,111,0,0,0,68,84.6a124.15,124.15,0,0,0-9.3,11.1,109.18,109.18,0,0,0-9.3,14.9,115.29,115.29,0,0,0,0,107,109.18,109.18,0,0,0,9.3,14.9A124.15,124.15,0,0,0,68,243.6a111,111,0,0,0,9.3,8.8c3,2.5,6.1,4.9,9.3,7.1,3,2.1,6.1,4,9.3,5.8a100.41,100.41,0,0,0,9.3,4.6,94.25,94.25,0,0,0,9.3,3.6,91,91,0,0,0,9.3,2.7c3.1.8,6.2,1.4,9.3,1.9s6.2.9,9.3,1.1,6.2.4,9.3.4h.3q4.5,0,9-.3C220.7,275.1,267.7,225.2,267.7,164.3Z",
    transform: "translate(-21.1 -16.6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.6,99.4a12.29,12.29,0,1,1-3.6-8.8A11.92,11.92,0,0,1,248.6,99.4Z",
    transform: "translate(-21.1 -16.6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.2,131.6a12.29,12.29,0,1,1-3.6-8.8A11.92,11.92,0,0,1,279.2,131.6Z",
    transform: "translate(-21.1 -16.6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224,228.7a12.29,12.29,0,1,1,3.6,8.8A12.08,12.08,0,0,1,224,228.7Z",
    transform: "translate(-21.1 -16.6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.6,196.5a12.29,12.29,0,1,1,3.6,8.8A11.92,11.92,0,0,1,254.6,196.5Z",
    transform: "translate(-21.1 -16.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKursObraczki);
export default __webpack_public_path__ + "static/media/kurs_obraczki.dcf816d92f3b693c5f7e52720d895eea.svg";
export { ForwardRef as ReactComponent };